import { ErrorMessageWrapper } from "@/common/components/ErrorMessageWrapper";
import ListHeader from "@/common/components/ListHeader";
import TextField from "@/common/components/TextField";
import useDebounce from "@/common/hooks/useDebounce";
import { useFilterParams } from "@/common/hooks/useFilterParams";
import { Mapper } from "@/common/services/mapper";
import { SearchIcon, ShoppingBasket } from "lucide-react";
import { RewardItemData, RewardItemTableItem } from "@/common/types/rewardItems";
import { useRewardItems } from "@/common/hooks/queries/useRewardItems";
import { RewardItemsTransformer } from "../../services/rewardItemsTransformer";
import { RewardItemsGridTable } from "../../components/RewardItemsGridTable";
import Button from "@/common/components/Button";
import { useNavigate } from "react-router-dom";
import { RedeemRewardItemModal } from "../../components/RedeemRewardItemModal";

const RewardItems = () => {
  const { filterParams, setFilterParams } = useFilterParams();
  const navigate = useNavigate()

  const [search, setSearch] = useDebounce(filterParams.search || '');

  const {
    data: rewardItems,
    meta,
    isPending: rewardItemsIsPending,
    isLoading: rewardItemsIsLoading,
    error: rewardItemsError = {} as any,
    refetch: refetchRewardItems,
  } = useRewardItems({
    filters: {
      search,
      page: filterParams.page || 1,
    },
    mapper: Mapper.mapWithTransformer<RewardItemData[], RewardItemTableItem[]>({
      transformer: RewardItemsTransformer.tableTransformer()
    })
  });

  return (
    <div className="flex flex-col h-[calc(100vh-64px)] gap-6">
      <ListHeader
        Icon={<ShoppingBasket className="w-10 h-10" strokeWidth={1} />}
        title="Itens para resgate"
        actions={(
          <div className="flex items-center gap-2">
            <RedeemRewardItemModal />
            <Button
              disabled={rewardItemsIsPending || rewardItemsError?.status === 403} 
              operationKlassToCheckPermission="Admin::Tmais::Products::Create"
              onClick={() => navigate('create')}
            >
              Cadastrar recompensa
            </Button>
          </div>
        )}
      />

      <ErrorMessageWrapper
        className="flex-1"
        statusCode={rewardItemsError?.status}
        refetchFunction={refetchRewardItems}
      >
        <div className="flex flex-col flex-1 overflow-auto gap-6">
          <div className="flex flex-col gap-4">
            <TextField
              name="search"
              LeftIcon={<SearchIcon />}
              placeholder="Pesquisar"
              className="rounded-sm shadow-[4px_0px_16px_0px_rgba(0,_0,_0,_0.5)]"
              onChange={(e) => {
                setSearch((e.target as HTMLInputElement).value);
                setFilterParams((prev) => ({ ...prev, search: (e.target as HTMLInputElement).value }));
              }}
              value={filterParams.search}
            />
          </div>

          <RewardItemsGridTable
            className="max-h-[calc(100vh-256px)]"
            rewardItems={rewardItems || []}
            page={filterParams.page || 1}
            totalPages={meta.total_pages || 1}
            totalCount={meta.total}
            setPage={(page) => setFilterParams((prev) => ({ ...prev, page }))}
            isLoadingData={rewardItemsIsLoading}
          />
        </div>
      </ErrorMessageWrapper>
    </div>
  );
};

export default RewardItems;
